import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import './ClientBlockedPage.css';

function ClientBlockedPage() {
  const { token, logout } = useAuth();
  const navigate = useNavigate();
  const [blockInfo, setBlockInfo] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBlockInfo = async () => {
      if (!token) {
        navigate('/login');
        return;
      }

      try {
        const response = await fetch('/api/client/me', {
          headers: { 'Authorization': `Bearer ${token}` }
        });

        if (response.status === 403) {
          const data = await response.json();
          if (data.code === 'ACCOUNT_BLOCKED') {
            setBlockInfo({
              reason: data.block_reason || 'Ваш аккаунт заблокирован',
              blocked_at: data.blocked_at
            });
            setLoading(false);
            return;
          }
        }

        // Если аккаунт не заблокирован, перенаправляем на главную
        if (response.ok) {
          navigate('/dashboard');
        }
      } catch (e) {
        console.error('Error fetching block info:', e);
      } finally {
        setLoading(false);
      }
    };

    fetchBlockInfo();
  }, [token, navigate]);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  if (loading) {
    return (
      <div className="blocked-page">
        <div className="blocked-container">
          <div className="loading-mini">Загрузка...</div>
        </div>
      </div>
    );
  }

  if (!blockInfo) {
    return null;
  }

  return (
    <div className="blocked-page">
      <div className="blocked-container">
        <div className="blocked-icon">🚫</div>
        <h1 className="blocked-title">Ваш аккаунт заблокирован</h1>
        
        <div className="blocked-reason">
          <h2>Причина блокировки:</h2>
          <p>{blockInfo.reason}</p>
        </div>

        <div className="blocked-warning">
          <p>⚠️ Если вы считаете, что вас заблокировали ошибочно, свяжитесь с администрацией.</p>
        </div>

        <div className="blocked-actions">
          <button 
            className="btn btn-primary"
            onClick={() => navigate('/dashboard/support')}
          >
            💬 Связаться с поддержкой
          </button>
          <button 
            className="btn btn-secondary"
            onClick={handleLogout}
          >
            Выйти из аккаунта
          </button>
        </div>
      </div>
    </div>
  );
}

export default ClientBlockedPage;

